import { Optional, YesNoAnswer } from "../commons.types";
import { InputSelectOption } from "../widgets/input-select.types";
import { VehicleType } from "./formik-accident.types";
import { FormikPhoneNumber } from "./formik-commons.types";

export enum VehicleOwnerType {
  NATURAL = "F",
  LEGAL = "G",
}

export enum ImpactPoint {
  FRONT_LEFT = "FS",
  FRONT_RIGHT = "FD",
  FRONT_CENTER = "FC",
  REAR_LEFT = "RS",
  REAR_RIGHT = "RD",
  REAR_CENTER = "RC",
  CENTER_LEFT = "CS",
  CENTER_RIGHT = "CD",
  PLACEHOLDER = "PL"
}

export type FormikVehicle = {
  owner: FormikVehicleOwner;
  contractor: FormikContractor;
  vehicleInfo: FormikVehicleInfo;
  company: FormikCompany;
  driver: FormikDriver;
  vehicleDamages: FormikVehicleDamages;
};

export type FormikVehicleDamages = {
  impactPoints: ImpactPoint[];
  documents?: FormikDocument[];
  notes: Optional<string>;
};

export type FormikVehicleOwner = {
  ownerCoincidesWithContractor: YesNoAnswer;
  name: string;
  surname: string;
  fiscalCodeOrVAT: string;
  phoneNumber: FormikPhoneNumber;
  email: string;
  address: string;
  placeOfBirth: string;
  dateOfBirth: string;
  subjectType: VehicleOwnerType;
};

export type FormikContractor = {
  name: string;
  surname: string;
  fiscalCodeOrVAT: string;
  address: string;
};

export type FormikVehicleInfo = {
  type: string;
  plate: string;
  registrationStatus: string;
};

export type FormikGreenCard = {
  number: string;
  startDate: string;
  endDate: string;
};

export type FormikCompany = {
  companyName: string;
  agencyName: string;
  policyNumber: string;
  greenCard: FormikGreenCard;
  materialDamageCoverage: YesNoAnswer;
  impresaDb?: number;
};

export type FormikDriver = {
  driverCoincidesWithContractor: YesNoAnswer;
  surname: string;
  name: string;
  dateOfBirth: string;
  fiscalCodeOrVAT: string;
  address: string;
  phoneNumber: FormikPhoneNumber;
  email: string;
  licenseNumber: string;
  category: Optional<InputSelectOption>;
  validUntil: string;
  fullName: string; //TODO: serve?
};

export type FormikDocument = {
  documentId: string;
  fileName: string;
  vehicleType: VehicleType;
};
